import { ROLES } from "../../../../const/roles"
import type { ApiRoleStrategy } from "../../../useRoleConf"

const MY_ADH_SUMMARY_ENDPOINT = "/api/adherents/my-adherent/summary"
const MY_ADH_SUMMARY_QUERY_KEY = ["adherents", "my-adherent", "summary"]

export const apiRoleConf: ApiRoleStrategy = {
  [ROLES.ADHERENT_HOLDER]: {
    endpoint: MY_ADH_SUMMARY_ENDPOINT,
    queryKey: MY_ADH_SUMMARY_QUERY_KEY,
  },
  [ROLES.ADHERENT_TEAM]: {
    endpoint: MY_ADH_SUMMARY_ENDPOINT,
    queryKey: MY_ADH_SUMMARY_QUERY_KEY,
  },
}
